import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import ScrollToTop from '@/components/shared/ScrollToTop/ScrollToTop.tsx';
import bg from '@/assets/img/simple_bg.png';

const Simple: FC = () => {
  return (
    <div
      className="flex flex-col grow min-h-screen justify-between gap-8 lg:gap-12 bg-cover bg-center"
      style={{
        backgroundImage: `url(${bg})`,
      }}
    >
      <ScrollToTop />
      <header id="app-header" className="flex" />
      <main id="app-main" className="flex grow">
        <Outlet />
      </main>
      <footer id="app-footer" className="flex" />
    </div>
  );
};

export default Simple;
